import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

// This component handles Publift page navigation events
// It should be placed at the top level of your app to catch all route changes
export default function PubliftNavigationHandler() {
  const location = useLocation();

  useLayoutEffect(() => {
    // Call fusetag.pageInit when the route changes
    if (window.fusetag?.pageInit) {
      // Get an initialisation-safe reference to the Fuse Queue
      const fusetag = window.fusetag || (window.fusetag = { que: [], pageInit: () => {}, registerZone: () => {} });

      fusetag.que.push(function() {
        // Tell fuse the navigation is complete, and
        // - Defer the auction until the header ad zone is registered
        // - This ensures ads are properly refreshed on navigation
        fusetag.pageInit({
          blockingFuseIds: [
            '23018547786'
          ]
        });
      });
    }
  }, [location.pathname]); // Re-run when the pathname changes

  return null; // This component doesn't render anything
}
